import SearchInput from './SearchInput'
import SearchResults from './SearchResults'
import ShowResultsButton from './ShowResultsButton'

import { useNoResults } from '../hooks'


const SearchWidget = ({ mapId }) => {
  const showNoResults = useNoResults()
  return (
    <div>
      <ShowResultsButton mapId={mapId} />
      <SearchInput mapId={mapId} />
      <SearchResults mapId={mapId} />
      {showNoResults && <div className="no-results">No Results Found</div>}
    </div>
  )
}

export default SearchWidget